import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'SelectModal',
    components: {},
})
export default class SelectModal<T> extends Vue {
    @Prop({ required: true })
    readonly title!: string;
    @Prop({ required: true })
    readonly all!: T[];
    @Prop({ required: true })
    readonly selected!: T[];
    @Prop({ required: true })
    readonly label!: ((T) => string) | string;
    @Prop({
        default: function () {// needs to be a function, not lambda, or else this will set to wrong instance
            return (this as SelectModal<T>).$t('generalNobody');
        },
    })
    readonly emptyText!: string;
    @Prop({ default: false })
    readonly showFooterButtons!: boolean;

    //
    private filter: string = '';

    open(): void {
        $(this.$refs.modal!).modal('show');
        this.filter = '';
    }

    dismiss(): void {
        $(this.$refs.modal!).modal('hide');
    }
    
    selectedButtonAction(): void {
        this.dismiss();
        this.$emit('selected');
    }

    private get labelFunc(): (T) => string {
        if (typeof (this.label) === 'function') {
            return this.label;
        } else {
            return (t: T) => '' + t;
        }
    }

    private get available(): T[] {
        return this.all.filter(e => !this.selected.includes(e));
    }

    private get selectedFiltered(): T[] {
        return this.selected
            .filter(r => !this.filter?.trim().length || this.labelFunc(r).toLocaleLowerCase().includes(this.filter.toLocaleLowerCase()))
            .sort((a, b) => this.labelFunc(a).toLocaleLowerCase().localeCompare(this.labelFunc(b).toLocaleLowerCase()));
    }

    private get availableFiltered(): T[] {
        return this.available
            .filter(u => !this.filter?.trim().length || this.labelFunc(u).toLocaleLowerCase().includes(this.filter.toLocaleLowerCase()))
            .sort((a, b) => this.labelFunc(a).toLocaleLowerCase().localeCompare(this.labelFunc(b).toLocaleLowerCase()));
    }

    private close(): void {

    }

    private add(t: T): void {
        this.$emit('add', t);
    }

    private remove(t: T): void {
        this.$emit('remove', t);
    }
}